module.exports = __webpack_public_path__ + "img/Big5Cats_DG.abc46777.png";